export const HOLIDAY_DAY_OF_WEEK = 10;
export const WEEK_DAYS = [1, 2, 3, 4, 5, 6, 7] as const;

export const DEFAULT_OPEN_TIME = "09:00";
export const DEFAULT_CLOSE_TIME = "18:00";

export type DayScheduleEntry = {
  dayOfWeek: number;
  enabled: boolean;
  openTime: string;
  closeTime: string;
};

export type HolidayScheduleEntry = {
  enabled: boolean;
  openTime: string;
  closeTime: string;
};

export type StoreHoursFormState = {
  days: DayScheduleEntry[];
  holiday: HolidayScheduleEntry;
  allDaysSameHour: boolean;
  resume?: string;
};
